export { default as EmailCapture } from './emailCapture'



// WEBPACK FOOTER //
// ./src/components/emailCapture/index.js